module.exports = __webpack_public_path__ + "static/media/mmlogo-RBE.966bd1ea.png";